define('viewModels/privileged/qm/facetedSearch/InteractionsSearchFacets',[
    'moment',
    'lib/knockout',

    'util/searchFacetFactory',
    'util/dateTimeConstant',

    'viewModels/ViewModel',
    'viewModels/privileged/qm/facetedSearch/SearchFacetsView',

    'viewModels/privileged/qm/policies/editors/AgentSelectorView',
    'viewModels/privileged/qm/policies/editors/AniSelectorView',
    'viewModels/privileged/qm/policies/editors/DnisSelectorView',
    'viewModels/privileged/qm/policies/editors/EvaluationFormSelectorView',
    'viewModels/privileged/qm/policies/editors/QueueSelectorView',
    'viewModels/privileged/qm/policies/editors/WrapupCodeSelectorView'
], function (
    moment,
    ko,

    searchFacetsFactory,
    dateTimeConstant,

    ViewModel,
    SearchFacetsView,

    AgentSelectorView,
    AniSelectorView,
    DnisSelectorView,
    EvaluationFormSelectorView,
    QueueSelectorView,
    WrapupCodeSelectorView
    ) {
    "use strict";

    var InteractionsSearchFacets = ViewModel.extend(function () {
        var self = this;

        var todayStart = moment().startOf('day').toDate();
        var todayEnd = moment().endOf('day').toDate();

        /**
         * Basic Construction of a facet
         *
         * name:            name of facet
         * cssClass:        used to apply styles
         * id:              unique identifier
         * custom: (optional) {
           *    display:    name of custom element
           *    operator:   used in query for retrieving ranges / results
           *    target:     used in query to retrieve type of result
           *    template:   used to create custom element,
           *    viewConstructor: used as template data
           *    },
         * popover: (optional) {
           *    display:    name of popover
           *    operator:   used in query for retrieving ranges / results
           *    target:     used in query to retrieve type of result
           *    template:   used to create popover,
           *    viewConstructor: used as template data
           *    },
         * multiSelect:     used for multi-select combo-boxes
         * options:         canned options for facets
         */

        self.dateRangeFilterObservable = ko.observable(todayStart.toISOString() + '/' + todayEnd.toISOString());

        //Set observables for popovers
        self.durationStart = ko.observable(0).extend({isDurationGreater: self.durationEnd});
        self.durationEnd = ko.observable(0).extend({isDurationLess: self.durationStart});

        self.lowInteger = ko.observable(0).extend({isScoreGreater: self.highInteger});
        self.highInteger = ko.observable(0).extend({isScoreLess: self.lowInteger});

        /**
         *  Search Facets
         */
        self.facets = {
            agent: {
                id: 'agentId',
                target: 'agentId',
                cssClass: 'agent-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.agent'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.agent'),
                operator: '=',
                custom: {
                    displayText: ko.i18n.renderString('searchFacet.pickAgent'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/agentPicker',
                    selectorViewConstructor: AgentSelectorView,
                    customConstructorArgs: {
                        userStates: ["active", "inactive"]
                    }
                }
            },
            dateRange: {
                id: 'interval',
                target: 'interval',
                cssClass: 'daterange-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.dateRange'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.dateRange'),
                operator: 'between',
                facetObservable: self.dateRangeValue,
                maxDate: todayEnd,
                popover: {
                    display: ko.i18n.renderString('searchFacet.customDateRange'),
                    target: 'interval',
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/customDateRangePicker',
                    data: {
                        dateRangeObservable: self.dateRangeFilterObservable,
                        showTimeRange: true,
                        customRanges: [
                            {
                                name: ko.i18n.renderString('dateRangePicker.today'),
                                value: [moment().startOf('day'), moment().endOf('day')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.yesterday'),
                                value: [moment.utc().subtract(1, 'days'), moment.utc().subtract(1, 'days')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.priorWeek'),
                                value: [moment.utc().subtract(1, 'week').startOf('week'), moment.utc().subtract(1, 'week').endOf('week')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.priorMonth'),
                                value: [moment.utc().subtract(1, 'month').startOf('month'), moment.utc().subtract(1, 'month').endOf('month')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.weekToDate'),
                                value: [moment.utc().startOf('week'), moment.utc().endOf('week')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.monthToDate'),
                                value: [moment.utc().startOf('month'), moment.utc().endOf('month')]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.last7'),
                                value: [moment.utc().subtract(6, 'days'), moment.utc()]
                            },
                            {
                                name: ko.i18n.renderString('dateRangePicker.last30'),
                                value: [moment.utc().subtract(29, 'days'), moment.utc()]
                            }
                        ]
                    }
                },
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('dateRangePicker.today'),
                        values: [moment().startOf('day').toISOString() + '/' + moment().endOf('day').toISOString()],
                        operator: 'between',
                        target: 'interval'
                    },{
                        display: ko.i18n.renderString('dateRangePicker.yesterday'),
                        values:[moment().startOf('day').subtract(1, 'days').toISOString() + '/' + moment().endOf('day').subtract(1, 'days').toISOString()],
                        operator: 'between',
                        target: 'interval'
                    },{
                        display: ko.i18n.renderString('dateRangePicker.weekToDate'),
                        values:[moment().startOf('week').toISOString() + '/' + moment().endOf('week').toISOString()],
                        operator: 'between',
                        target: 'interval'
                    },{
                        display: ko.i18n.renderString('dateRangePicker.monthToDate'),
                        values:[moment().startOf('month').toISOString() + '/' + moment().endOf('month').toISOString()],
                        operator: 'between',
                        target: 'interval'
                    },
                    {
                        display: ko.i18n.renderString('dateRangePicker.last31'),
                        values:[moment().subtract('days', 30).startOf('day').toISOString() + '/' + moment().endOf('day').toISOString()],
                        operator: 'between',
                        target: 'interval'
                    }
                ]
            },
            duration: {
                id: "duration",
                target: "duration",
                operator: 'between',
                cssClass: "duration-accordion-item",
                popover: {
                    display: ko.i18n.renderString('searchFacet.customRange'),
                    target: 'duration',
                    template:'templates/appMain/privilegedMain/qm/facetedSearch/customDurationRangePicker',
                    data: {
                        durationStart: self.durationStart,
                        durationEnd: self.durationEnd
                    }
                },
                displayString: ko.i18n.renderString('searchFacet.heading.duration'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.duration'),
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('searchFacet.duration.0to60'),
                        values: ['0/60000'],
                        operator: 'between',
                        target: 'duration'
                    }, {
                        display: ko.i18n.renderString('searchFacet.duration.1to5'),
                        values: ['60000/300000'],
                        operator: 'between',
                        target: 'duration'
                    }, {
                        display: ko.i18n.renderString('searchFacet.duration.5to10'),
                        values: ['300000/600000'],
                        operator: 'between',
                        target: 'duration'
                    }, {
                        display: ko.i18n.renderString('searchFacet.duration.10to20'),
                        values: ['600000/1200000'],
                        operator: 'between',
                        target: 'duration'
                    }, {
                        display: ko.i18n.renderString('searchFacet.duration.20plus'),
                        values: ['1200000/363599000'],
                        operator: '>=',
                        target: 'duration'
                    }
                ]
            },
            queue: {
                id: 'queueId',
                target: 'queueId',
                cssClass: 'queue-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.queues'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.queue'),
                operator: '=',
                custom: {
                    display: ko.i18n.renderString('searchFacet.pickQueue'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/queuePicker',
                    selectorViewConstructor: QueueSelectorView
                }
            },
            ani: {
                id: 'ani',
                target: 'ani',
                cssClass: 'ani-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.ani'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.ani'),
                operator: 'contains',
                custom: {
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/aniPicker',
                    selectorViewConstructor: AniSelectorView
                }
            },
            dnis: {
                id: 'dnis',
                target: 'dnis',
                cssClass: 'dnis-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.dnis'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.dnis'),
                operator: 'contains',
                custom: {
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/dnisPicker',
                    selectorViewConstructor: DnisSelectorView
                }
            },
            direction: {
                id: 'direction',
                target: 'direction',
                cssClass: 'direction-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.direction'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.direction'),
                operator: '=',
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('searchFacet.direction.inbound'),
                        values: ["INBOUND"],
                        operator: '=',
                        target: 'direction'
                    },{
                        display: ko.i18n.renderString('searchFacet.direction.outbound'),
                        values: ["OUTBOUND"],
                        operator: '=',
                        target: 'direction'
                    }
                ]
            },
            wrapup: {
                id: 'wrapupCode',
                target: 'wrapupCode',
                cssClass: 'wrap-up-code-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.wrapupCode'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.wrapUpCode'),
                operator: '=',
                custom: {
                    displayText: ko.i18n.renderString('searchFacet.pickWrapupCode'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/wrapUpCodePicker',
                    selectorViewConstructor: WrapupCodeSelectorView
                }
            },
            evaluationScore: {
                id: "qualityEvaluationScore",
                target: 'qualityEvaluationScore',
                cssClass: "evaluation-score-accordion-item",
                displayString: ko.i18n.renderString('searchFacet.heading.evaluationScore'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.evaluationScore'),
                operator: 'between',
                popover: {
                    target: 'qualityEvaluationScore',
                    display: ko.i18n.renderString('searchFacet.customRange'),
                    template:'templates/appMain/privilegedMain/qm/facetedSearch/customScorePicker',
                    data: {
                        lowInteger: self.lowInteger,
                        highInteger: self.highInteger
                    }
                },
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.25orLess'),
                        filterString: ko.i18n.renderString("evaluationScoreFacet.scoreRange.between", {lowInteger: 0, highInteger: 25}),
                        values: ['0/25'],
                        target: 'qualityEvaluationScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.26to50'),
                        filterString: ko.i18n.renderString("evaluationScoreFacet.scoreRange.between", {lowInteger: 25, highInteger: 50}),
                        values: ['25/50'],
                        target: 'qualityEvaluationScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.51to75'),
                        filterString: ko.i18n.renderString("evaluationScoreFacet.scoreRange.between", {lowInteger: 50, highInteger: 75}),
                        values: ['50/75'],
                        target: 'qualityEvaluationScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.76to100'),
                        filterString: ko.i18n.renderString("evaluationScoreFacet.scoreRange.between", {lowInteger: 75, highInteger: 100}),
                        values: ['75/100'],
                        target: 'qualityEvaluationScore'
                    }
                ]
            },
            evaluationCriticalScore: {
                id: "qualityEvaluationCriticalScore",
                target: 'qualityEvaluationCriticalScore',
                cssClass: "evaluation-critical-score-accordion-item",
                displayString: ko.i18n.renderString('searchFacet.heading.evaluationCriticalScore'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.evaluationCriticalScore'),
                operator: 'between',
                popover: {
                    target: 'qualityEvaluationScore',
                    display: ko.i18n.renderString('searchFacet.customRange'),
                    template:'templates/appMain/privilegedMain/qm/facetedSearch/customScorePicker',
                    data: {
                        lowInteger: self.lowInteger,
                        highInteger: self.highInteger
                    }
                },
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.25orLess'),
                        filterString: ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.between", {lowInteger: 0, highInteger: 25}),
                        values: ['0/25'],
                        target: 'qualityEvaluationCriticalScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.26to50'),
                        filterString: ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.between", {lowInteger: 25, highInteger: 50}),
                        values: ['25/50'],
                        target: 'qualityEvaluationCriticalScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.51to75'),
                        filterString: ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.between", {lowInteger: 50, highInteger: 75}),
                        values: ['50/75'],
                        target: 'qualityEvaluationCriticalScore'
                    }, {
                        display: ko.i18n.renderString('searchFacet.evaluationScore.76to100'),
                        filterString: ko.i18n.renderString("evaluationCriticalScoreFacet.scoreRange.between", {lowInteger: 75, highInteger: 100}),
                        values: ['75/100'],
                        target: 'qualityEvaluationCriticalScore'
                    }
                ]
            },
            evaluationForm: {
                id: 'qualityEvaluationForm',
                target: 'qualityEvaluationForm',
                cssClass: 'evaluation-form-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.evaluationForm'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.qualityEvaluationForm'),
                operator: '=',
                custom: {
                    displayText: ko.i18n.renderString('searchFacet.pickEvaluationForm'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/evaluationFormPicker',
                    selectorViewConstructor: EvaluationFormSelectorView
                }
            },
            evaluatedAgent: {
                id: 'qualityEvaluationAgent',
                target: 'qualityEvaluationAgent',
                cssClass: 'evaluated-agent-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.evaluatedAgent'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.qualityEvaluationAgent'),
                operator: '=',
                custom: {
                    displayText: ko.i18n.renderString('searchFacet.pickEvaluatedAgent'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/agentPicker',
                    selectorViewConstructor: AgentSelectorView,
                    customConstructorArgs: {
                        userStates: ["active", "inactive"]
                    }
                }
            },
            evaluator: {
                id: 'qualityEvaluator',
                target: 'qualityEvaluator',
                cssClass: 'evaluator-accordion-item',
                displayString: ko.i18n.renderString('searchFacet.heading.evaluator'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.qualityEvaluator'),
                operator: '=',
                custom: {
                    displayText: ko.i18n.renderString('searchFacet.pickEvaluator'),
                    template: 'templates/appMain/privilegedMain/qm/facetedSearch/agentPicker',
                    selectorViewConstructor: AgentSelectorView,
                    customConstructorArgs: {
                        userStates: ["active", "inactive"]
                    }
                }
            },
            mediaType: {
                id: "mediaType",
                target: 'mediaType',
                cssClass: "mediaType-accordion-item",
                displayString: ko.i18n.renderString('searchFacet.heading.mediaType'),
                filterTitle: ko.i18n.renderString('searchFacet.filterTitle.mediaType'),
                operator: '=',
                cannedOptions: [
                    {
                        display: ko.i18n.renderString('searchFacet.mediaType.call'),
                        values: ["VOICE"],
                        operator: '=',
                        target: 'mediaType'
                    },
                    {
                        display: ko.i18n.renderString('searchFacet.mediaType.callback'),
                        values: ["CALLBACK"],
                        operator: '=',
                        target: 'mediaType'
                    },
                    {
                        display: ko.i18n.renderString('searchFacet.mediaType.chat'),
                        values: ["CHAT"],
                        operator: '=',
                        target: 'mediaType'
                    },
                    {
                        display: ko.i18n.renderString('searchFacet.mediaType.email'),
                        values: ["EMAIL"],
                        operator: '=',
                        target: 'mediaType'
                    }
                ]
            }
        };

    });
    return InteractionsSearchFacets;
});

